import React from "react";
import { createBrowserRouter } from "react-router-dom";
import ErrorPage from "../Pages/Shared/ErrorPage";
import Login from "../Pages/Login/Login";
import Signup from "../Pages/Login/Signup";
import Main from "../Layout/Main";
import ComingSoon from "../Pages/Shared/ComingSoon";
import PrivateRoute from "./PrivateRoute";
import DashboardLayout from "../Layout/DashboardLayout";
import Welcome from "../Pages/Dashboard/Welcome";
import AdminRoute from "./AdminRoute";
import HomeAll from "../Pages/HomeAll";
import AdminDashboard from "../Components/Dashboard/AdminAllPage/AdminDashboard/AdminDashboard";
import MyProducts from "../Components/Dashboard/AdminAllPage/MyProducts/MyProducts";
import AddProducts from "../Components/Dashboard/AdminAllPage/AddProducts/AddProducts";
import Orders from "../Components/Dashboard/AdminAllPage/Orders/Orders";
import AllUsersAdmin from "../Components/Dashboard/AdminAllPage/AllUsersAdmin/AllUsersAdmin";
import EventCart from "../Pages/Cart/EventCart";
import EventAllProductsDetails from "../Pages/EventAllProducts/EventAllProductsDetails";
import EventAdminDashboard from "../Pages/Dashboard/Admin/EventAdminDashboard/EventAdminDashboard";
import AddInventory from "../Pages/Dashboard/Admin/AddInventory/AddInventory";
import MyAccount from "../Pages/Dashboard/Admin/MyAccount/MyAccount";
import AllInventoryDetails from "../Pages/Dashboard/Admin/AddInventory/AllInventoryDetails";
import AllInventory from "../Pages/Dashboard/Admin/AddInventory/AllInventory";
import EventProducts from "../Pages/HomeEventManagement/EventProducts";
import EventProductDetails from "../Pages/HomeEventManagement/EventProductDetails";
import BuildWishlist from "../Pages/HomeEventManagement/BuildWishlist";
import RentalsProduct from "../Pages/HomeEventManagement/RentalsProduct";
import Projects from "../Pages/Dashboard/Admin/Projects/Projects";
import ProjectTest from "../Pages/Dashboard/Admin/Projects/ProjectTest";
import ProjectDetails from "../Pages/Dashboard/Admin/Projects/ProjectDetails";
import InventoryMain from "../Pages/Dashboard/Admin/AddInventory/InventoryMain";
import EventInvoice from "../Pages/EventInvoicePayment/EventInvoice";
import MainInvoice from "../Pages/EventInvoicePayment/MainInvoice";
import EventPayment from "../Pages/EventInvoicePayment/EventPayment";
import FinanceMainPage from "../Pages/Dashboard/Admin/Finance/FinanceMainPage";
import MainPullSheet from "../Pages/pullSheet/MainPullSheet";
import PullSheetView from "../Pages/pullSheet/PullSheetView";

import ViewInvoice from "../Pages/EventInvoicePayment/ViewInvoice";
import RentalMainPage from "../Pages/WebsitePage/RentalMainPage";
import EventMainPage from "../Pages/WebsitePage/EvenMainPage";
import AboutUs from "../Pages/HomeEventManagement/AboutUs";
import AddGallary from "../Pages/Dashboard/Admin/AddGallary/AddGallary";
import Category from "../Components/Dashboard/Website/Category";
import SubCategory from "../Components/Dashboard/Website/SubCategory";
import SubCategoryDetails from "../Components/Dashboard/Website/SubCategoryDetails";
import CategoryDetails from "../Components/Dashboard/Website/CategoryDetails";
import GalleryAdmin from "../Components/Dashboard/Website/GalleryAdmin";
import GalleryDetails from "../Components/Dashboard/Website/GalleryDetails";
import InstagramPostAdmin from "../Components/Dashboard/Website/InstagramPostAdmin";
import ExpoAdmin from "../Components/Dashboard/Website/ExpoAdmin";
import AboutUsAdmin from "../Components/Dashboard/Website/AboutUsAdmin";
import AboutUsAdminDetails from "../Components/Dashboard/Website/AboutUsAdminDetails";
import TestimonialAdmin from "../Components/Dashboard/Website/TestimonialAdmin";
import TestimonialCollectionDetails from "../Components/Dashboard/Website/TestimonialCollectionDetails";
import ConsultationRequest from "../Components/Dashboard/Website/ConsultationRequest";
import PackageAdmin from "../Components/Dashboard/Website/PackageAdmin";
import PackageImageDetails from "../Components/Dashboard/Website/PackageImageDetails";

import InventoryOne from "../Pages/Dashboard/Admin/AddInventory/InventoryOne";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Main />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: "/",
        element: <HomeAll></HomeAll>,
      },
      {
        path: "/build-wishlist",
        element: <BuildWishlist />,
      },
      // {
      //   path: "/login",
      //   element: <LoginV />,
      // },
      // {
      //   path: "/signup",
      //   element: <SignUpV />,
      // },
      {
        path: "/login",
        element: <Login />,
      },
      {
        path: "/signup",
        element: <Signup />,
      },
      {
        path: "/cart",
        element: <EventCart></EventCart>,
      },

      {
        path: "/coming-soon",
        element: <ComingSoon />,
      },

      // {
      //   path: '/products',
      //   element: <ProductsList />,
      //   loader: ({ request }) => {
      //     const url = new URL(request.url);
      //     const page = url.searchParams.get('page') || 1; // Get page from URL query params
      //     return fetch(`https://server-gs.vercel.app/products?page=${page}&limit=5`);
      //   },
      // },

      {
        path: "/rental",
        element: <RentalMainPage />,
      },
      {
        path: "/event",
        element: <EventMainPage></EventMainPage>,
      },
      {
        path: "/about",
        element: <AboutUs></AboutUs>,
      },

      {
        path: "/product-details/:id", // Product details page route
        element: <EventAllProductsDetails />,
        loader: ({ params }) =>
          fetch(`https://server-gs.vercel.app/products/${params.id}`), // Fetch product details using ID
      },
      {
        path: "/event-all-products/:Event",
        element: <EventProducts />,
        loader: async ({ params, request }) => {
          const url = new URL(request.url);
          const page = url.searchParams.get("page") || 1;
          return fetch(
            `https://server-gs.vercel.app/web/event-products/${params.Event}?page=${page}`
          ).then((res) => res.json());
        },
      },
      {
        path: "/rental-all-products/:category",
        element: <RentalsProduct />,
        loader: async ({ params, request }) => {
          const url = new URL(request.url);
          const page = url.searchParams.get("page") || 1;
          return fetch(
            `https://server-gs.vercel.app/web/category-products/${params.category}?page=${page}`
          ).then((res) => res.json());
        },
      },
      {
        path: "/event-products-details/:id", // Product details page route
        element: <EventProductDetails />,
        loader: ({ params }) =>
          fetch(
            `https://server-gs.vercel.app/web/event-products-details/${params.id}`
          ), // Fetch product details using ID
      },
      {
        path: "/event-invoice/:id", // Product details page route
        element: <EventInvoice />,
        loader: ({ params }) =>
          fetch(`https://server-gs.vercel.app/admin/orders/${params.id}`), // Fetch product details using ID
      },
    ],
  },
  {
    path: "/dashboard",
    errorElement: <ErrorPage />,
    element: (
      <PrivateRoute>
        <DashboardLayout />
      </PrivateRoute>
    ),
    children: [
      {
        path: "",
        element: (
          <PrivateRoute>
            <Welcome />
          </PrivateRoute>
        ),
      },
      {
        path: "admin-dashboard",
        element: (
          <AdminRoute>
            <AdminDashboard />
          </AdminRoute>
        ),
      },
      {
        path: "my-product",
        element: (
          <AdminRoute>
            <MyProducts />
          </AdminRoute>
        ),
      },
      {
        path: "add-product",
        element: (
          <AdminRoute>
            <AddProducts />
          </AdminRoute>
        ),
      },
      {
        path: "orders",
        element: (
          <AdminRoute>
            <Orders />
          </AdminRoute>
        ),
      },
      {
        path: "all-users",
        element: (
          <AdminRoute>
            <AllUsersAdmin />
          </AdminRoute>
        ),
      },
      // E-END

      // EVENT ADMIN START
      {
        path: "event-dashboard",
        element: (
          <AdminRoute>
            <EventAdminDashboard />
          </AdminRoute>
        ),
      },
      {
        path: "admin-projects",
        element: (
          <AdminRoute>
            <Projects />
          </AdminRoute>
        ),
      },

      {
        path: "admin-projects-test",
        element: (
          <AdminRoute>
            <ProjectTest />
          </AdminRoute>
        ),
        loader: ({ request }) => {
          const url = new URL(request.url);
          const page = url.searchParams.get("page") || 1;
          const dateFilter = url.searchParams.get("dateFilter") || "";
          const fromDate = url.searchParams.get("fromDate") || "";
          const toDate = url.searchParams.get("toDate") || "";
          const phoneNumber = url.searchParams.get("phoneNumber") || "";
          const email = url.searchParams.get("email") || "";
          const position = url.searchParams.get("position") || "";
          const status = url.searchParams.get("status") || "";
          const emailStatus = url.searchParams.get("emailStatus") || "";
          const name = url.searchParams.get("name") || ""; 
          const filterType = url.searchParams.get("filterType") || "";

          return fetch(
            `https://server-gs.vercel.app/admin/orders?page=${page}&limit=30&status=${status}&emailStatus=${emailStatus}&position=${position}&dateFilter=${dateFilter}&fromDate=${fromDate}&toDate=${toDate}&phoneNumber=${phoneNumber}&email=${email}&name=${name}filterType=${filterType}`
          );
        },
      },
      {
        path: "admin-project-details/:id", // Product details page route
        element: <ProjectDetails />,
        loader: ({ params }) =>
          fetch(`https://server-gs.vercel.app/admin/orders/${params.id}`), // Fetch product details using ID
      },

      {
        path: "add-gallery",
        element: (
          <AdminRoute>
            <AddGallary />
          </AdminRoute>
        ),
      },

      {
  path: "inventory",
  element: (
    <AdminRoute>
      <InventoryOne />
    </AdminRoute>
  ),
  loader: () => null, // ❗ important: disable loader data fetching
},

      {
        path: "inventory-details/:id", // Product details page route
        element: (
          <AdminRoute>
            <AllInventoryDetails></AllInventoryDetails>
          </AdminRoute>
        ),
        loader: ({ params }) =>
          fetch(`https://server-gs.vercel.app/admin/products/${params.id}`), // Fetch product details using ID
      },
      {
        path: "admin-stripe-pay",
        element: (
          <AdminRoute>
            <FinanceMainPage />
          </AdminRoute>
        ),
        loader: ({ request }) => {
          const url = new URL(request.url);
          const page = url.searchParams.get("page") || 1;
          const dateFilter = url.searchParams.get("dateFilter") || "";
          const fromDate = url.searchParams.get("fromDate") || "";
          const toDate = url.searchParams.get("toDate") || "";
          const phoneNumber = url.searchParams.get("phoneNumber") || "";
          const name = url.searchParams.get("name") || "";

          return fetch(
            `https://server-gs.vercel.app/stripe/payment-list?page=${page}&limit=50&dateFilter=${dateFilter}&fromDate=${fromDate}&toDate=${toDate}&phoneNumber=${phoneNumber}&name=${name}`
          );
        },
      },
      {
        path: "my-account",
        element: (
          <AdminRoute>
            <MyAccount />
          </AdminRoute>
        ),
      },

      // EVENT ADMIN END

      // web admin start
      {
        path: "admin-category",
        element: (
          <AdminRoute>
            <Category />
          </AdminRoute>
        ),
        loader: ({ request }) => {
          const url = new URL(request.url);
          const page = url.searchParams.get("page") || 1;
          const dateFilter = url.searchParams.get("dateFilter") || "";
          const fromDate = url.searchParams.get("fromDate") || "";
          const toDate = url.searchParams.get("toDate") || "";
          const phoneNumber = url.searchParams.get("phoneNumber") || "";
          const selectedCategory =
            url.searchParams.get("selectedCategory") || "";
          const selectedEventsData =
            url.searchParams.get("selectedEventsData") || "";
          const SelectedType = url.searchParams.get("SelectedType") || "";
          const productCode = url.searchParams.get("productCode") || "";
          const title = url.searchParams.get("title") || "";

          return fetch(
            `https://server-gs.vercel.app/admin/main-category?page=${page}&limit=20&dateFilter=${dateFilter}&fromDate=${fromDate}&toDate=${toDate}&phoneNumber=${phoneNumber}&selectedCategory=${selectedCategory}&selectedEventsData=${selectedEventsData}&SelectedType=${SelectedType}&productCode=${productCode}&title=${title}`
          );
        },
      },

      {
        path: "category-main-details/:id", // Product details page route
        element: (
          <AdminRoute>
            <CategoryDetails></CategoryDetails>
          </AdminRoute>
        ),
        loader: ({ params }) =>
          fetch(
            `https://server-gs.vercel.app/admin/main-category/${params.id}`
          ), // Fetch product details using ID
      },
      {
        path: "admin-subCategory",
        element: (
          <AdminRoute>
            <SubCategory />
          </AdminRoute>
        ),
        loader: ({ request }) => {
          const url = new URL(request.url);
          const page = url.searchParams.get("page") || 1;
          const dateFilter = url.searchParams.get("dateFilter") || "";
          const fromDate = url.searchParams.get("fromDate") || "";
          const toDate = url.searchParams.get("toDate") || "";
          const phoneNumber = url.searchParams.get("phoneNumber") || "";
          const selectedCategory =
            url.searchParams.get("selectedCategory") || "";
          const selectedEventsData =
            url.searchParams.get("selectedEventsData") || "";
          const SelectedType = url.searchParams.get("SelectedType") || "";
          const productCode = url.searchParams.get("productCode") || "";
          const category = url.searchParams.get("category") || "";
          const title = url.searchParams.get("title") || "";

          return fetch(
            `https://server-gs.vercel.app/admin/sub-category?page=${page}&limit=20&dateFilter=${dateFilter}&fromDate=${fromDate}&toDate=${toDate}&phoneNumber=${phoneNumber}&selectedCategory=${selectedCategory}&category=${category}&selectedEventsData=${selectedEventsData}&SelectedType=${SelectedType}&productCode=${productCode}&title=${title}`
          );
        },
      },

      {
        path: "subCategory-details/:id", // Product details page route
        element: (
          <AdminRoute>
            <SubCategoryDetails></SubCategoryDetails>
          </AdminRoute>
        ),
        loader: ({ params }) =>
          fetch(`https://server-gs.vercel.app/admin/sub-category/${params.id}`), // Fetch product details using ID
      },
      {
        path: "admin-gallery",
        element: (
          <AdminRoute>
            <GalleryAdmin />
          </AdminRoute>
        ),
        loader: ({ request }) => {
          const url = new URL(request.url);
          const page = url.searchParams.get("page") || 1;
          const dateFilter = url.searchParams.get("dateFilter") || "";
          const fromDate = url.searchParams.get("fromDate") || "";
          const toDate = url.searchParams.get("toDate") || "";
          const phoneNumber = url.searchParams.get("phoneNumber") || "";
          const selectedCategory =
            url.searchParams.get("selectedCategory") || "";
          const selectedEventsData =
            url.searchParams.get("selectedEventsData") || "";
          const SelectedType = url.searchParams.get("SelectedType") || "";
          const productCode = url.searchParams.get("productCode") || "";
          const title = url.searchParams.get("title") || "";

          return fetch(
            `https://server-gs.vercel.app/admin/main-gallery?page=${page}&limit=10&dateFilter=${dateFilter}&fromDate=${fromDate}&toDate=${toDate}&phoneNumber=${phoneNumber}&selectedCategory=${selectedCategory}&selectedEventsData=${selectedEventsData}&SelectedType=${SelectedType}&productCode=${productCode}&title=${title}`
          );
        },
      },
      {
        path: "gallery-details/:id", // Product details page route
        element: (
          <AdminRoute>
            <GalleryDetails></GalleryDetails>
          </AdminRoute>
        ),
        loader: ({ params }) =>
          fetch(
            `https://server-gs.vercel.app/admin/gallery-details/${params.id}`
          ), // Fetch product details using ID
      },
        {
        path: "admin-package",
        element: (
          <AdminRoute>
            <PackageAdmin />
          </AdminRoute>
        ),
        loader: ({ request }) => {
          const url = new URL(request.url);
          const page = url.searchParams.get("page") || 1;
          const dateFilter = url.searchParams.get("dateFilter") || "";
          const fromDate = url.searchParams.get("fromDate") || "";
          const toDate = url.searchParams.get("toDate") || "";
          const phoneNumber = url.searchParams.get("phoneNumber") || "";
          const selectedCategory =
            url.searchParams.get("selectedCategory") || "";
          const selectedEventsData =
            url.searchParams.get("selectedEventsData") || "";
          const SelectedType = url.searchParams.get("SelectedType") || "";
          const productCode = url.searchParams.get("productCode") || "";
          const title = url.searchParams.get("title") || "";

          return fetch(
            `https://server-gs.vercel.app/admin/main-gallery?page=${page}&limit=10&dateFilter=${dateFilter}&fromDate=${fromDate}&toDate=${toDate}&phoneNumber=${phoneNumber}&selectedCategory=${selectedCategory}&selectedEventsData=${selectedEventsData}&SelectedType=${SelectedType}&productCode=${productCode}&title=${title}`
          );
        },
      },
         {
        path: "package-details/:id", // Product details page route
        element: (
          <AdminRoute>
            <PackageImageDetails></PackageImageDetails>
          </AdminRoute>
        ),
        loader: ({ params }) =>
          fetch(
            `https://server-gs.vercel.app/admin/package-details/${params.id}`
          ), // Fetch product details using ID
      },
      {
        path: "admin-instagram-post",
        element: (
          <AdminRoute>
            <InstagramPostAdmin />
          </AdminRoute>
        ),
        loader: ({ request }) => {
          const url = new URL(request.url);
          const page = url.searchParams.get("page") || 1;
          const dateFilter = url.searchParams.get("dateFilter") || "";
          const fromDate = url.searchParams.get("fromDate") || "";
          const toDate = url.searchParams.get("toDate") || "";
          const phoneNumber = url.searchParams.get("phoneNumber") || "";
          const selectedCategory =
            url.searchParams.get("selectedCategory") || "";
          const selectedEventsData =
            url.searchParams.get("selectedEventsData") || "";
          const SelectedType = url.searchParams.get("SelectedType") || "";
          const productCode = url.searchParams.get("productCode") || "";
          const title = url.searchParams.get("title") || "";

          return fetch(
            `https://server-gs.vercel.app/admin/instagram-post?page=${page}&limit=10&dateFilter=${dateFilter}&fromDate=${fromDate}&toDate=${toDate}&phoneNumber=${phoneNumber}&selectedCategory=${selectedCategory}&selectedEventsData=${selectedEventsData}&SelectedType=${SelectedType}&productCode=${productCode}&title=${title}`
          );
        },
      },
      {
        path: "admin-expo",
        element: (
          <AdminRoute>
            <ExpoAdmin />
          </AdminRoute>
        ),
        loader: ({ request }) => {
          const url = new URL(request.url);
          const page = url.searchParams.get("page") || 1;
          const dateFilter = url.searchParams.get("dateFilter") || "";
          const fromDate = url.searchParams.get("fromDate") || "";
          const toDate = url.searchParams.get("toDate") || "";
          const phone = url.searchParams.get("phone") || "";
          const expoId = url.searchParams.get("expoId") || "";
          const selectedCategory =
            url.searchParams.get("selectedCategory") || "";
          const selectedEventsData =
            url.searchParams.get("selectedEventsData") || "";
          const SelectedType = url.searchParams.get("SelectedType") || "";
          const productCode = url.searchParams.get("productCode") || "";
          const title = url.searchParams.get("title") || "";

          return fetch(
            `https://server-gs.vercel.app/admin/expo-post?page=${page}&limit=10&dateFilter=${dateFilter}&fromDate=${fromDate}&toDate=${toDate}&phone=${phone}&expoId=${expoId}&selectedCategory=${selectedCategory}&selectedEventsData=${selectedEventsData}&SelectedType=${SelectedType}&productCode=${productCode}&title=${title}`
          );
        },
      },
       {
        path: "admin-consultation",
        element: (
          <AdminRoute>
            <ConsultationRequest />
          </AdminRoute>
        ),
        loader: ({ request }) => {
          const url = new URL(request.url);
          const page = url.searchParams.get("page") || 1;
          const dateFilter = url.searchParams.get("dateFilter") || "";
          const fromDate = url.searchParams.get("fromDate") || "";
          const toDate = url.searchParams.get("toDate") || "";
          const phone = url.searchParams.get("phone") || "";
          const expoId = url.searchParams.get("expoId") || "";
          const selectedCategory =
            url.searchParams.get("selectedCategory") || "";
          const selectedEventsData =
            url.searchParams.get("selectedEventsData") || "";
          const SelectedType = url.searchParams.get("SelectedType") || "";
          const productCode = url.searchParams.get("productCode") || "";
          const title = url.searchParams.get("title") || "";

          return fetch(
            `https://server-gs.vercel.app/admin/booking-post?page=${page}&limit=10&dateFilter=${dateFilter}&fromDate=${fromDate}&toDate=${toDate}&phone=${phone}&expoId=${expoId}&selectedCategory=${selectedCategory}&selectedEventsData=${selectedEventsData}&SelectedType=${SelectedType}&productCode=${productCode}&title=${title}`
          );
        },
      },
      {
        path: "admin-about-us",
        element: (
          <AdminRoute>
            <AboutUsAdmin />
          </AdminRoute>
        ),
        loader: ({ request }) => {
          const url = new URL(request.url);
          const page = url.searchParams.get("page") || 1;
          const dateFilter = url.searchParams.get("dateFilter") || "";
          const fromDate = url.searchParams.get("fromDate") || "";
          const toDate = url.searchParams.get("toDate") || "";
          const phoneNumber = url.searchParams.get("phoneNumber") || "";
          const selectedCategory =
            url.searchParams.get("selectedCategory") || "";
          const selectedEventsData =
            url.searchParams.get("selectedEventsData") || "";
          const SelectedType = url.searchParams.get("SelectedType") || "";
          const productCode = url.searchParams.get("productCode") || "";
          const title = url.searchParams.get("title") || "";

          return fetch(
            `https://server-gs.vercel.app/admin/team-member?page=${page}&limit=20&dateFilter=${dateFilter}&fromDate=${fromDate}&toDate=${toDate}&phoneNumber=${phoneNumber}&selectedCategory=${selectedCategory}&selectedEventsData=${selectedEventsData}&SelectedType=${SelectedType}&productCode=${productCode}&title=${title}`
          );
        },
      },
      {
        path: "admin-about-us/:id", // Product details page route
        element: (
          <AdminRoute>
            <AboutUsAdminDetails></AboutUsAdminDetails>
          </AdminRoute>
        ),
        loader: ({ params }) =>
          fetch(
            `https://server-gs.vercel.app/admin/about-us/${params.id}`
          ), // Fetch product details using ID
      },
      {
        path: "admin-testimonial",
        element: (
          <AdminRoute>
            <TestimonialAdmin />
          </AdminRoute>
        ),
        loader: ({ request }) => {
          const url = new URL(request.url);
          const page = url.searchParams.get("page") || 1;
          const dateFilter = url.searchParams.get("dateFilter") || "";
          const fromDate = url.searchParams.get("fromDate") || "";
          const toDate = url.searchParams.get("toDate") || "";
          const phoneNumber = url.searchParams.get("phoneNumber") || "";
          const selectedCategory =
            url.searchParams.get("selectedCategory") || "";
          const selectedEventsData =
            url.searchParams.get("selectedEventsData") || "";
          const SelectedType = url.searchParams.get("SelectedType") || "";
          const productCode = url.searchParams.get("productCode") || "";
          const title = url.searchParams.get("title") || "";

          return fetch(
            `https://server-gs.vercel.app/admin/team-member?page=${page}&limit=20&dateFilter=${dateFilter}&fromDate=${fromDate}&toDate=${toDate}&phoneNumber=${phoneNumber}&selectedCategory=${selectedCategory}&selectedEventsData=${selectedEventsData}&SelectedType=${SelectedType}&productCode=${productCode}&title=${title}`
          );
        },
      },
      {
        path: "admin-testimonial/:id", // Product details page route
        element: (
          <AdminRoute>
            <TestimonialCollectionDetails></TestimonialCollectionDetails>
          </AdminRoute>
        ),
        loader: ({ params }) =>
          fetch(
            `https://server-gs.vercel.app/admin/testimonial/${params.id}`
          ), // Fetch product details using ID
      },
      // web admin end
    ],
  },
  {
    path: "/invoice",
    element: <MainInvoice />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: "view-invoice/:id", // Product details page route
        // element: <EventInvoice />,
        element: <ViewInvoice />,
        loader: ({ params }) =>
          fetch(`https://server-gs.vercel.app/admin/orders/${params.id}`), // Fetch product details using ID
      },
      {
        path: "payment/:id", // Product details page route
        element: <EventPayment />,
        // element: <StripePayment />,
        // element: <PaymentLink />,
        loader: ({ params }) =>
          fetch(`https://server-gs.vercel.app/admin/orders/${params.id}`), // Fetch product details using ID
      },
    ],
  },
  {
    path: "/pullSheet",
    element: <MainPullSheet />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: "view-pullSheet/:id", // Product details page route
        element: <PullSheetView />,
        loader: ({ params }) =>
          fetch(`https://server-gs.vercel.app/admin/orders/${params.id}`), // Fetch product details using ID
      },
    ],
  },
]);

export default router;
